<script lang="ts">
	interface Props {
		level?: string;
		className?: string;
		fontClasses?: string;
		children?: import('svelte').Snippet;
	}

	let {
		level = '1',
		className = '',
		fontClasses = 'font-title font-extralight',
		children
	}: Props = $props();

	let font = $state('');

	// bg-gradient-to-r from-primary to-primary bg-clip-text text-transparent
	switch (level) {
		case '1':
			font = 'xl:text-4xl text-3xl';
			break;
		case '2':
			font = 'xl:text-2xl text-xl';
			break;
		case '3':
			font = 'xl:text-xl text-lg';
			break;
		case '4':
			font = 'xl:text-lg text-base';
			break;
	}
</script>

<h1 class="{fontClasses} {font} {className}">
	{@render children?.()}
</h1>
